import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_trash.svg';
import Icon, { IconProps } from './icon';

const IconTrash = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTrash;
